import {getOnboardingSampleDataPrefs} from 'common/helpers/onboardingSampleData'
import {X} from 'lucide-react'
import {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router'
import {RootState} from 'setup'
import {hideSampleReadOnlyPopup} from 'setup/redux/Actions/SampleReadOnly/sampleReadOnly'

import {useT} from '_metronic/i18n/t'

// the AI Timetable page, when the sample's branch/level/session are not known
const AI_TIMETABLE_PATH = '/institute/schedule/timetable'

/**
 * "Try generating a sample timetable first": shown when a data change is attempted on the
 * da1timetable sample data (see useSampleReadOnly). Closing it leaves the page unchanged;
 * "Try Sample Timetable" opens the Master Timetable Generation page for the sample's branch,
 * level and session. Mounted once, in MasterLayout.
 */
const SampleReadOnlyModal: FC = () => {
  const t = useT()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const show = useSelector<RootState>(
    ({sampleReadOnlyReducer}) => sampleReadOnlyReducer.showPopup
  ) as boolean
  const userPreferences = useSelector<RootState>(
    ({mainReducer}) => mainReducer.userPreferences
  ) as Record<string, unknown> | null

  const close = () => {
    dispatch(hideSampleReadOnlyPopup())
  }

  const trySampleTimetable = () => {
    const sample = getOnboardingSampleDataPrefs(userPreferences)
    close()
    navigate(
      sample?.branchId && sample?.levelId && sample?.durationId
        ? `/institute/schedule/timetable/new-version/${sample.branchId}/${sample.levelId}/${sample.durationId}`
        : AI_TIMETABLE_PATH
    )
  }

  return (
    <Modal
      show={show}
      onHide={close}
      centered
      aria-labelledby='sample-read-only-modal-title'
      className='sample-read-only-modal'
      contentClassName='sample-read-only-modal__content'
      dialogClassName='sample-read-only-modal__dialog'
    >
      <button
        type='button'
        className='sample-read-only-modal__close'
        onClick={close}
        aria-label={t('GENERAL.CLOSE')}
      >
        <X size={18} strokeWidth={2} aria-hidden />
      </button>

      <div className='sample-read-only-modal__body'>
        <h2 id='sample-read-only-modal-title' className='sample-read-only-modal__title'>
          {t('SAMPLE_DATA.READ_ONLY.TITLE')}
        </h2>
        <p className='sample-read-only-modal__text'>{t('SAMPLE_DATA.READ_ONLY.BODY')}</p>

        <button
          type='button'
          className='sample-read-only-modal__cta'
          onClick={trySampleTimetable}
        >
          {t('SAMPLE_DATA.READ_ONLY.CTA')}
        </button>

        <p className='sample-read-only-modal__footer'>{t('SAMPLE_DATA.READ_ONLY.FOOTER')}</p>
      </div>
    </Modal>
  )
}

export default SampleReadOnlyModal
